<div
  class="widget-preset-card"
  [class.selectable]="selectable"
  [class.selected]="selectable && selected"
  [attr.role]="selectable ? 'button' : null"
  [attr.tabindex]="selectable ? 0 : null"
  [attr.aria-pressed]="selectable ? selected : null"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  (keydown.space)="onCardClick(); $event.preventDefault()"
>
  <fa-icon
    *ngIf="selectable"
    class="selection-check"
    [icon]="selected ? ['fas', 'square-check'] : ['far', 'square']"
  ></fa-icon>

  <div
    class="card-title"
    [innerHTML]="widgetPreset.name | highlight: highlight"
  ></div>
  <p [innerHTML]="widgetPreset.description | highlight: highlight"></p>
  <div class="widget-viz-types">
    <div
      id="widget-presets"
      *ngFor="let viz of widgetPreset.chart_types"
      class="viz-type"
      [class.viz-type--selected]="selectable && isVizTypeSelected(viz.id)"
      (click)="onVizTypeClick(viz, $event)"
    >
      <app-widget-visualization-type-card
        [chartId]="widgetPreset.id"
        [chartTypeId]="viz.id"
        [dataSourceObjectId]="dataSourceObjectId"
        [dataSourceObjectClassId]="dataSourceObjectClassId"
        [selected]="isVizTypeSelected(viz.id)"
        suiTooltip="{{ viz.name }}"
      ></app-widget-visualization-type-card>
    </div>
  </div>
  <div class="tools"></div>
</div>
